import React from 'react';
import PropTypes from 'prop-types';


const ScrollArea = ({ children }) => {
    return (
        <div className="scroll-area">
            {children}
        </div>
    );
};

ScrollArea.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ScrollArea;